import { defineMessages } from "react-intl";

import { node as cmv } from "src/modules/ltx/forms/phase-i/viral-serology/cmv";
import { node as ebvSerology } from "src/modules/ltx/forms/phase-i/viral-serology/ebvSerology";
import { node as hiv } from "src/modules/ltx/forms/phase-i/viral-serology/hiv";
import { node as hsv1Serology } from "src/modules/ltx/forms/phase-i/viral-serology/hsv1Serology";
import { node as hsv2Serology } from "src/modules/ltx/forms/phase-i/viral-serology/hsv2Serology";
import { node as toxoplasmaSerology } from "src/modules/ltx/forms/phase-i/viral-serology/toxoplasmaSerology";
import { node as treponemaPallidum } from "src/modules/ltx/forms/phase-i/viral-serology/treponemaPallidum";
import { node as varicellaSerology } from "src/modules/ltx/forms/phase-i/viral-serology/varicellaSerology";
import { node as hbvStatus } from "src/modules/ltx/forms/phase-i/viral-serology/hbvStatus";
import { node as hcv } from "src/modules/ltx/forms/phase-i/viral-serology/hcv";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.ltx_viral_serology",
		defaultMessage: "Vírusszerológia"
	}
});

export const node: ParentNode = {
	id: "viralSerology",
	value: { type: "list", title: messages.title },
	children: [
		cmv,
		ebvSerology,
		toxoplasmaSerology,
		varicellaSerology,
		hsv1Serology,
		hsv2Serology,
		hiv,
		treponemaPallidum,
		hbvStatus,
		hcv
	]
};
